<div class="px-4 py-4 md:px-8 md:py-8 self-stretch flex-col gap-4 flex h-full">
  <div class="PaymentInput self-stretch p-4 md:p-6 rounded-xl shadow flex-col gap-3 flex bg-[#F2F2F2] h-full"
    (click)="bookingInfo?.orderStatus !== 'Cancelled' && goToBookingOverview()"
    [ngClass]="{'cursor-pointer': bookingInfo?.orderStatus != 'Cancelled'}">

    <!-- Header with Order & Car Info -->
    <div class="flex justify-between items-center w-full gap-1 flex-wrap md:flex-nowrap">
      <div class="flex gap-2 md:gap-3 items-center flex-wrap">
        <div class="text-lg md:text-xl font-semibold text-[#1B3777] ml-1 md:ml-3">{{'KEY_TASKS.ORDER' | transloco}} #{{
          booking?.orderNumber }}</div>
        @if (booking?.orderStatus) {
        <app-status-badge [text]="$safeNavigationMigration(booking?.orderStatus)" [isPayment]="true"></app-status-badge>
        }

      </div>
      <div class="flex items-center justify-end">
        <a routerLinkActive="active" ariaCurrentWhenActive="page"
          class="h-full items-center LeadingIconLUseHighEmphasis justify-start gap-0.5 flex cursor-pointer">
          @switch (booking?.organizationName?.toLowerCase()) {
          @case ('skavsta') {
          <img class="mr-2 max-w-[100px] md:max-w-[150px]" src="../../../../../assets/img/skavsta-logo.png" />
          }
          @case ('flygets.se') {
          <img class="mr-2 max-w-[100px] md:max-w-[150px]" src="../../../../../assets/img/thumbnail_Flygets-logo.png" />
          }
          @case ('ving') {
          <img class="mr-2 max-w-[100px] md:max-w-[150px]" src="../../../../../assets/img/thumbnail_Flygets-logo.png" />
          }
          @case ('mdpark') {
          <img class="mr-2 max-w-[100px] md:max-w-[150px] logo-mdpark"
            src="../../../../../assets/img/mdpark_logo.png" />
          }
          @case ('nazar') {
          <img class="logo-margin-right max-w-[80px] md:max-w-[100px]"
            src="../../../../../assets/img/nasar_logo.png" />
          }
          @case ('tui') {
          <img class="logo-margin-right max-w-[80px] md:max-w-[100px]"
            src="../../../../../assets/img/SE_TUI_3CPM_transparent_blue_Co_coop.png" />
          }
          }
        </a>
      </div>

    </div>

    <!-- Header with Order & Car Info -->
    <div class="flex justify-between items-center w-full flex-wrap gap-2">
      <div class="flex gap-2 md:gap-3 items-center flex-wrap">
        <div class="text-sm md:text-md font-medium flex items-center gap-1">
          <mat-icon class="text-base md:text-lg">directions_bus</mat-icon>
          <span>{{ booking?.carRegNumber }}</span>
        </div>
        <div class="text-xs md:text-sm font-medium flex items-center gap-1">
          <mat-icon class="text-base md:text-lg">people</mat-icon>
          <span>{{ booking?.passengers }}</span>
        </div>
        @if (booking?.orderStatus?.toLowerCase() === 'checkout' || booking?.orderStatus?.toLowerCase() ===
        'checkoutadditional' || booking?.orderStatus?.toLowerCase() === 'driveup') {
        <div class="payment-container text-xs md:text-sm font-medium flex items-center gap-1" (click)="goToPayment()">
          <mat-icon>credit_card</mat-icon>
          <span>{{ 'MY_ORDERS.PAYMENT_REQUIRED' | transloco }}</span>
        </div>
        }
      </div>
      <div
        class="text-sm md:text-md font-medium flex justify-start md:justify-end items-center gap-1 max-w-full break-words">
        <mat-icon class="shrink-0 text-base md:text-lg">local_parking</mat-icon>
        <span class="break-words"> {{ booking?.parking }} </span>
      </div>
    </div>

    <!-- Departure & Arrival Details -->
    <div
      class="border border-blue-200 bg-[white] rounded-lg p-3 md:p-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 text-sm text-gray-700 mt-3">
      <div class="text-neutral-800 text-sm md:text-md font-normal leading-[21px] w-full sm:w-auto">
        <div class="flex items-center ml-[6px]">
          <span class="font-semibold text-[#1B3777] text-base md:text-lg">
            {{((site === 'flygets' ? "PARKIFLY.SUMMARY.ARRIVAL_AT_PARKING" :
            'PARKIFLY.SIMPLE_SEARCH_SELECT.DEPARTURE_HEADING') | transloco) + ": "}}
          </span>
        </div>
        <div class="flex items-center">
          <mat-icon class="ml-[6px] icon-flex-center">event_seat</mat-icon>
          <div>
            @if(booking?.parkingFrom) {
            {{
            ($safeNavigationMigration(booking?.parkingFrom) | date:'yyyy-MM-dd') + " " +
            " " + ("PARKIFLY.CLOCK_SHORT" | transloco) + " " + ( $safeNavigationMigration(booking?.parkingFrom)|
            date:'HH:mm')
            }}
            }
          </div>
        </div>
        @if(booking?.parkingFrom) {
        @if(booking?.departure) {
        @if(booking?.departure?.departureCode) {
        @let flightDetails = $safeNavigationMigration(booking?.departure);
        <div class="flex items-center">
          <svg width="14" height="13" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="ml-[6px] svg-margin-left-half">
            <path
              d="M5.885 -7.05719e-05H8.085L13.0218 8.80103H18.7C18.7 8.80103 22 8.80103 22 10.3399C22 11.8799 18.7 11.8799 18.7 11.8799H13.0218L8.085 20.6799H5.885L8.6218 11.8799H4.6761L2.2 14.081H0L1.7611 10.341L0 6.59993H2.2L4.6761 8.80103H8.6218L5.885 -7.05719e-05Z"
              fill="black" />
          </svg>
          <div class="ml-[6px] text-margin-left">
            {{ flightDetails?.arrivalStation + ", " +
            booking?.departure?.departureCode }}
          </div>
        </div>
        <div class="flex items-center">
          <svg width="14" height="13" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="opacity-0 svg-margin-left-half">
            <path
              d="M5.885 -7.05719e-05H8.085L13.0218 8.80103H18.7C18.7 8.80103 22 8.80103 22 10.3399C22 11.8799 18.7 11.8799 18.7 11.8799H13.0218L8.085 20.6799H5.885L8.6218 11.8799H4.6761L2.2 14.081H0L1.7611 10.341L0 6.59993H2.2L4.6761 8.80103H8.6218L5.885 -7.05719e-05Z"
              fill="black" />
          </svg>
          <div class="ml-[6px] text-margin-left">
            {{ ($safeNavigationMigration(flightDetails?.scheduledDeparture) | date:'yyyy-MM-dd') +
            " " + ("PARKIFLY.CLOCK_SHORT" | transloco) + " " +
            ((flightDetails ? $safeNavigationMigration(flightDetails?.scheduledDeparture) : '') | date:'HH:mm')
            }}
          </div>
        </div>
        }@else {
        <div class="flex items-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="svg-margin-left-3px">
            <path
              d="M9.27273 12.2728C10.1782 12.2728 10.9091 11.5419 10.9091 10.6365C10.9091 9.731 10.1782 9.00009 9.27273 9.00009C8.36727 9.00009 7.63636 9.731 7.63636 10.6365C7.63636 11.5419 8.36727 12.2728 9.27273 12.2728ZM15.8182 9.00009H11.4545V12.8183H7.09091V7.90918H6V16.091H7.09091V14.4546H16.9091V16.091H18V11.1819C18 9.97645 17.0236 9.00009 15.8182 9.00009Z"
              fill="black" />
          </svg>
          <div>
            {{booking?.departure?.terminalName}}
          </div>
        </div>
        }}}
      </div>

      <div
        class="flex items-center justify-center font-small text-xs text-[#1b3777] self-center sm:self-auto my-1 sm:my-0">
        <div class="px-3 py-1 bg-[#bdd5ff] rounded-full whitespace-nowrap">
          @if(bookingDuration > 1){
          {{ bookingDuration }} {{'MY_ORDERS.DAYS' | transloco}}
          } @else {
          {{ bookingDuration }} {{'MY_ORDERS.DAY' | transloco}}
          }
        </div>
      </div>

      <div class="text-neutral-800 text-sm md:text-md font-normal leading-[21px] w-full sm:w-auto">
        <div class="flex items-center ml-[6px]">
          <span class="font-semibold text-[#1B3777] text-base md:text-lg">
            {{((site === 'flygets' ? "PARKIFLY.SUMMARY.RETURN_TRIP" :
            'PARKIFLY.SIMPLE_SEARCH_SELECT.ARRIVAL_HEADING') | transloco) + ": "}}
          </span>
        </div>
        <div class="flex items-center">
          <mat-icon class="ml-[6px] icon-flex-center">event_seat</mat-icon>
          <div>
            @if(booking?.parkingTo) {
            {{
            ($safeNavigationMigration(booking?.parkingTo) | date:'yyyy-MM-dd') + " " +
            " " + ("PARKIFLY.CLOCK_SHORT" | transloco) + " " + ( $safeNavigationMigration(booking?.parkingTo) |
            date:'HH:mm')
            }}
            }
          </div>
        </div>
        @if(booking?.parkingTo) {
        @if(booking?.arrival) {
        @if(booking?.arrival?.arrivalCode) {
        @let flightDetails = $safeNavigationMigration(booking?.arrival);
        <div class="flex items-center">
          <svg width="14" height="13" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="ml-[6px] rotate-180">
            <path
              d="M5.885 -7.05719e-05H8.085L13.0218 8.80103H18.7C18.7 8.80103 22 8.80103 22 10.3399C22 11.8799 18.7 11.8799 18.7 11.8799H13.0218L8.085 20.6799H5.885L8.6218 11.8799H4.6761L2.2 14.081H0L1.7611 10.341L0 6.59993H2.2L4.6761 8.80103H8.6218L5.885 -7.05719e-05Z"
              fill="black" />
          </svg>
          <div class="ml-[6px] text-margin-left">
            {{ flightDetails?.departureStation + ", " +
            booking?.arrival?.arrivalCode}}
          </div>
        </div>
        <div class="flex items-center">
          <svg width="14" height="13" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="ml-[6px] opacity-0">
            <path
              d="M5.885 -7.05719e-05H8.085L13.0218 8.80103H18.7C18.7 8.80103 22 8.80103 22 10.3399C22 11.8799 18.7 11.8799 18.7 11.8799H13.0218L8.085 20.6799H5.885L8.6218 11.8799H4.6761L2.2 14.081H0L1.7611 10.341L0 6.59993H2.2L4.6761 8.80103H8.6218L5.885 -7.05719e-05Z"
              fill="black" />
          </svg>
          <div class="ml-[6px] text-margin-left">
            {{
            ($safeNavigationMigration(flightDetails?.scheduledArrival) | date:'yyyy-MM-dd') +
            " " + ("PARKIFLY.CLOCK_SHORT" | transloco) + " " +
            ((flightDetails ? $safeNavigationMigration(flightDetails?.scheduledArrival) : '') | date:'HH:mm')
            }}
          </div>
        </div>
        }@else {
        <div class="flex items-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="svg-margin-left-3px">
            <path
              d="M9.27273 12.2728C10.1782 12.2728 10.9091 11.5419 10.9091 10.6365C10.9091 9.731 10.1782 9.00009 9.27273 9.00009C8.36727 9.00009 7.63636 9.731 7.63636 10.6365C7.63636 11.5419 8.36727 12.2728 9.27273 12.2728ZM15.8182 9.00009H11.4545V12.8183H7.09091V7.90918H6V16.091H7.09091V14.4546H16.9091V16.091H18V11.1819C18 9.97645 17.0236 9.00009 15.8182 9.00009Z"
              fill="black" />
          </svg>
          <div>
            {{booking?.arrival?.terminalName}}
          </div>
        </div>
        }
        }
        }
      </div>
    </div>
  </div>
</div>